const options = {
  5: "bg-orange-50/5",
  10: "bg-orange-50/10",
  25: "bg-orange-50/25",
  50: "bg-orange-50/50",
  75: "bg-orange-50/75",
  90: "bg-orange-50/90",
  100: "bg-orange-50",
};

const from = {
  5: "from-orange-50/5",
  10: "from-orange-50/10",
  25: "from-orange-50/25",
  50: "from-orange-50/50",
  75: "from-orange-50/75",
  90: "from-orange-50/90",
  100: "from-orange-50",
};

export default function getBackgroundOrange50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
